export const useInvoicesTypes = false;
export const useSalesStatement = true;
export const multipleWarehouses  = false;
export const separationOfInvoices = false;
export const isMangeUnitAndRegionAndPatchAndLot = false
export const useSaleInvoiceReceipts = false
export const useBuyInvoicePayments = false
export const useBuyInvoiceExpenses = false
export const useMaterialStatusDeliver = false
// export const 